class CartRecommendations extends HTMLElement {

	constructor(){
		super();
		this.generateRecommendations();
	}

	// One request per anchor product (the first cart line), only while the cart drawer is open.
	generateRecommendations(){
		if ( ! document.getElementById('site-cart-sidebar')?._opened ) return;
		const anchor = document.getElementById('AjaxCartForm')?.querySelector('[data-js-cart-item]')?.dataset.productId;
		if ( ! anchor ) return;
		if ( anchor === this._anchor && ( this._loading || this._none || this.querySelector('[data-js-product-item]') ) ) return;
		const request = this._request = {};
		this._anchor = anchor;
		this._loading = true;
		this._none = false;
		fetch(`${KROWN.settings.routes.product_recommendations_url}?section_id=${this.dataset.section}&product_id=${anchor}&limit=${this.dataset.limit}`)
			.then(response => {
				if ( ! response.ok ) throw new Error(response.status);
				return response.text();
			})
			.then(text => {
				if ( request !== this._request ) return;
				const innerHTML = OrdoUtils.parseHTML(text)
					.querySelector('[data-js-cart-recommendations-performed]');
				if ( innerHTML && innerHTML.querySelectorAll('[data-js-product-item]').length > 0 ) {
					this.innerHTML = innerHTML.innerHTML;
					this._shown = anchor;
				} else {
					this._none = true;
					this._clearUnless(anchor);
				}
			})
			.catch(() => {
				// Forget the anchor so the next open retries.
				if ( request !== this._request ) return;
				this._anchor = null;
				this._clearUnless(anchor);
			})
			.finally(() => {
				if ( request === this._request ) this._loading = false;
			});
	}

	// A list made for another first line no longer fits the cart.
	_clearUnless(anchor){
		if ( this._shown === anchor ) return;
		this.innerHTML = '';
		this._shown = null;
	}
}
if ( ! customElements.get('cart-recommendations') ) {
	customElements.define('cart-recommendations', CartRecommendations);
}
